module.exports = __webpack_public_path__ + "media/PAG86-07.cf61fe35.mp3";